import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { typographyPrefixCls } from "@/base/components/typography/Typography.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Typography">> = ({
  fontWeightStrong,
  colorPrimary,
  fontSizeSmall,
  fontMediumSmall,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${typographyPrefixCls}`]: {
      margin: 0,

      [`&.${typographyPrefixCls}-link`]: {
        // borderBottom: "1px dashed"
      },

      [`strong`]: {
        fontWeight: fontWeightStrong,
      },

      [`&.${typographyPrefixCls}-primary`]: {
        color: colorPrimary,
      },

      [`&.${typographyPrefixCls}-size-small`]: {
        fontSize: `${fontSizeSmall}`,
      },

      [`&.${typographyPrefixCls}-size-middle`]: {
        fontSize: `${fontMediumSmall}`,
      },
    },
  },
});

export const useTypographyStyle = genComponentStyleHook(
  ["Typography", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
